module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/awesome-typescript-loader/dist/entry.js?silent=true!./accounting-settings-popup.ts"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy!./ClientApp/components/accounting-settings-popup/accounting-settings-popup.ts
// module id = 104
// module chunks = 53